"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Contract = _interopRequireDefault(require("./Contract"));
var _ServiceLifeCycle = _interopRequireDefault(require("./ServiceLifeCycle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Service model module.
 * @module model/Service
 * @version 3.0
 */
var Service = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Service</code>.
   * @alias module:model/Service
   */
  function Service() {
    _classCallCheck(this, Service);
    Service.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Service, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>Service</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Service} obj Optional instance to populate.
     * @return {module:model/Service} The populated <code>Service</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Service();
        if (data.hasOwnProperty('serviceLegacyId')) {
          obj['serviceLegacyId'] = _ApiClient["default"].convertToType(data['serviceLegacyId'], 'String');
        }
        if (data.hasOwnProperty('displayName')) {
          obj['displayName'] = _ApiClient["default"].convertToType(data['displayName'], 'String');
        }
        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'String');
        }
        if (data.hasOwnProperty('startDate')) {
          obj['startDate'] = _ApiClient["default"].convertToType(data['startDate'], 'Date');
        }
        if (data.hasOwnProperty('endDate')) {
          obj['endDate'] = _ApiClient["default"].convertToType(data['endDate'], 'Date');
        }
        if (data.hasOwnProperty('lineIdentifier')) {
          obj['lineIdentifier'] = _ApiClient["default"].convertToType(data['lineIdentifier'], 'String');
        }
        if (data.hasOwnProperty('serviceType')) {
          obj['serviceType'] = _ApiClient["default"].convertToType(data['serviceType'], 'String');
        }
        if (data.hasOwnProperty('billingMode')) {
          obj['billingMode'] = _ApiClient["default"].convertToType(data['billingMode'], 'String');
        }
        if (data.hasOwnProperty('serviceLifeCycle')) {
          obj['serviceLifeCycle'] = _ServiceLifeCycle["default"].constructFromObject(data['serviceLifeCycle']);
        }
        if (data.hasOwnProperty('source')) {
          obj['source'] = _ApiClient["default"].convertToType(data['source'], 'String');
        }
        if (data.hasOwnProperty('ownerOfPrimaryIdentifier')) {
          obj['ownerOfPrimaryIdentifier'] = _ApiClient["default"].convertToType(data['ownerOfPrimaryIdentifier'], 'Boolean');
        }
        if (data.hasOwnProperty('primaryIdentifier')) {
          obj['primaryIdentifier'] = _ApiClient["default"].convertToType(data['primaryIdentifier'], 'String');
        }
        if (data.hasOwnProperty('contract')) {
          obj['contract'] = _Contract["default"].constructFromObject(data['contract']);
        }
        if (data.hasOwnProperty('serviceId')) {
          obj['serviceId'] = _ApiClient["default"].convertToType(data['serviceId'], 'Number');
        }
        if (data.hasOwnProperty('billCycleDay')) {
          obj['billCycleDay'] = _ApiClient["default"].convertToType(data['billCycleDay'], 'Number');
        }
        if (data.hasOwnProperty('nextBillDate')) {
          obj['nextBillDate'] = _ApiClient["default"].convertToType(data['nextBillDate'], 'Date');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Service</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Service</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['serviceLegacyId'] && !(typeof data['serviceLegacyId'] === 'string' || data['serviceLegacyId'] instanceof String)) {
        throw new Error("Expected the field `serviceLegacyId` to be a primitive type in the JSON string but got " + data['serviceLegacyId']);
      }
      // ensure the json data is a string
      if (data['displayName'] && !(typeof data['displayName'] === 'string' || data['displayName'] instanceof String)) {
        throw new Error("Expected the field `displayName` to be a primitive type in the JSON string but got " + data['displayName']);
      }
      // ensure the json data is a string
      if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
        throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
      }
      // ensure the json data is a string
      if (data['lineIdentifier'] && !(typeof data['lineIdentifier'] === 'string' || data['lineIdentifier'] instanceof String)) {
        throw new Error("Expected the field `lineIdentifier` to be a primitive type in the JSON string but got " + data['lineIdentifier']);
      }
      // ensure the json data is a string
      if (data['serviceType'] && !(typeof data['serviceType'] === 'string' || data['serviceType'] instanceof String)) {
        throw new Error("Expected the field `serviceType` to be a primitive type in the JSON string but got " + data['serviceType']);
      }
      // ensure the json data is a string
      if (data['billingMode'] && !(typeof data['billingMode'] === 'string' || data['billingMode'] instanceof String)) {
        throw new Error("Expected the field `billingMode` to be a primitive type in the JSON string but got " + data['billingMode']);
      }
      // validate the optional field `serviceLifeCycle`
      if (data['serviceLifeCycle']) {
        // data not null
        _ServiceLifeCycle["default"].validateJSON(data['serviceLifeCycle']);
      }
      // ensure the json data is a string
      if (data['source'] && !(typeof data['source'] === 'string' || data['source'] instanceof String)) {
        throw new Error("Expected the field `source` to be a primitive type in the JSON string but got " + data['source']);
      }
      // ensure the json data is a string
      if (data['primaryIdentifier'] && !(typeof data['primaryIdentifier'] === 'string' || data['primaryIdentifier'] instanceof String)) {
        throw new Error("Expected the field `primaryIdentifier` to be a primitive type in the JSON string but got " + data['primaryIdentifier']);
      }
      // validate the optional field `contract`
      if (data['contract']) {
        // data not null
        _Contract["default"].validateJSON(data['contract']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {String} serviceLegacyId
 */
Service.prototype['serviceLegacyId'] = undefined;

/**
 * @member {String} displayName
 */
Service.prototype['displayName'] = undefined;

/**
 * @member {String} status
 */
Service.prototype['status'] = undefined;

/**
 * @member {Date} startDate
 */
Service.prototype['startDate'] = undefined;

/**
 * @member {Date} endDate
 */
Service.prototype['endDate'] = undefined;

/**
 * @member {String} lineIdentifier
 */
Service.prototype['lineIdentifier'] = undefined;

/**
 * @member {String} serviceType
 */
Service.prototype['serviceType'] = undefined;

/**
 * @member {String} billingMode
 */
Service.prototype['billingMode'] = undefined;

/**
 * @member {module:model/ServiceLifeCycle} serviceLifeCycle
 */
Service.prototype['serviceLifeCycle'] = undefined;

/**
 * @member {String} source
 */
Service.prototype['source'] = undefined;

/**
 * @member {Boolean} ownerOfPrimaryIdentifier
 */
Service.prototype['ownerOfPrimaryIdentifier'] = undefined;

/**
 * @member {String} primaryIdentifier
 */
Service.prototype['primaryIdentifier'] = undefined;

/**
 * @member {module:model/Contract} contract
 */
Service.prototype['contract'] = undefined;

/**
 * @member {Number} serviceId
 */
Service.prototype['serviceId'] = undefined;

/**
 * @member {Number} billCycleDay
 */
Service.prototype['billCycleDay'] = undefined;

/**
 * @member {Date} nextBillDate
 */
Service.prototype['nextBillDate'] = undefined;
var _default = exports["default"] = Service;